@if (IS_TRS_PROJECT && teaserBox.isSplit) {
  <div style="display: flex; justify-content: space-between; flex-direction: column">
    @for (item of teaserBox.items; track item) {
      <div
        [ngClass]="cssClasses"
        [ngStyle]="{ background: item.backgroundColor }"
        [style.height]="'calc((100% / ' + teaserBox.items.length + ') - 0px)'"
        [style.margin-bottom.px]="$index === 0 ? 25 : 0">
        <div class="card-body" style="text-align: center">
          @if (item.faIcon) {
            <div
              (click)="item.click && item.click()"
              [ngClass]="{ clickable: item.headerLink || item.click }"
              [ngStyle]="{ color: item.faIconColor || item.backgroundColor }"
              [routerLink]="item.disabled ? null : item.headerLink"
              class="exclamation">
              <fa-icon [icon]="item.faIcon"></fa-icon>
            </div>
          }
          @if (item.image) {
            <div [ngStyle]="{ padding: '0px 0px 10px 0px' }" class="card-img">
              <img src="{{ item.image }}" />
            </div>
          }
          <h5 class="card-title">
            <span [ngStyle]="{ 'font-size': item.fontSizeHeader + 'px', color: item.fontColorHeader, 'padding-top': '15' }">
              {{ item.title | translate }}
            </span>
          </h5>
          @if (item.text) {
            <div [innerHTML]="item.text" [ngStyle]="{ 'font-size': item.fontSizeText + 'px', color: item.fontColorText }"></div>
          }
          <ng-content />
        </div>
        @if (item.externalLink) {
          <a (click)="$event.stopPropagation()" [href]="item.externalLink" [ngStyle]="{ color: item.fontColorText }" class="external-link" target="_blank">
            <fa-icon icon="external-link-alt"></fa-icon>
          </a>
        }
      </div>
    }
  </div>
}

@if (IS_PRODUCT_SAFETY_PROJECT || (IS_TRS_PROJECT && !teaserBox.isSplit)) {
  <div [ngClass]="cssClasses">
    <div class="card-body">
      @if (teaserBox.faIcon) {
        <div
          [ngClass]="{ clickable: teaserBox.headerLink }"
          [ngStyle]="{ color: teaserBox.faIconColor || teaserBox.backgroundColor }"
          [routerLink]="teaserBox.disabled ? null : teaserBox.headerLink"
          class="exclamation">
          <fa-icon [icon]="teaserBox.faIcon"></fa-icon>
        </div>
      }
      @if (teaserBox.image) {
        <div [ngStyle]="{ padding: '0px 0px 10px 0px' }" class="card-img">
          <img src="{{ teaserBox.image }}" />
        </div>
      }
      <h5 class="card-title">
        <span [ngStyle]="{ 'font-size': teaserBox.fontSizeHeader + 'px', color: teaserBox.fontColorHeader, 'padding-top': '15' }">
          {{ teaserBox.title | translate }}
        </span>
      </h5>
      @if (teaserBox.text) {
        <div [innerHTML]="teaserBox.text" [ngStyle]="{ 'font-size': teaserBox.fontSizeText + 'px', color: teaserBox.fontColorText }"></div>
      }
      <ng-content />
    </div>
    @if (teaserBox.externalLink) {
      <a
        (click)="$event.stopPropagation()"
        [href]="teaserBox.externalLink"
        [ngStyle]="{ color: teaserBox.fontColorText }"
        class="external-link"
        target="_blank">
        <fa-icon icon="external-link-alt"></fa-icon>
      </a>
    }
  </div>
}
